// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pencil';

export const Component = () => (
  <path d='M18.421 3.431 21.2 6.21c.288.288.431.623.431 1.054 0 .48-.143.814-.43 1.006L8.267 21.2c-.24.288-.575.431-1.006.431H3.959a.946.946 0 0 1-.67-.287.976.976 0 0 1-.288-.719v-3.257c0-.431.144-.766.431-1.005L16.362 3.43A1.378 1.378 0 0 1 17.369 3c.479 0 .814.144 1.054.431ZM7.598 20.481 18.757 9.32l-3.448-3.448-11.207 11.16-.144.335v3.257h3.304c.144 0 .24-.047.336-.144ZM19.475 8.602l1.054-1.005c.096-.192.144-.288.144-.335 0-.048-.048-.192-.144-.383L17.75 4.102a.542.542 0 0 0-.383-.144.434.434 0 0 0-.335.144l-1.054 1.053 3.496 3.449Z' />
);

export const viewBox = '0 0 25 25';
